/**** Open Cart Drawer Function ****/
function openCartDrawer() {
    $('.cart_drawer').addClass('active');
    $('body').addClass('overflow-hidden');
}

/**** Close Cart Drawer Function ****/
function closeCartDrawer() {
    $('.cart_drawer').removeClass('active');
    $('body').removeClass('overflow-hidden');
}
/**** Progreshbar animation ****/
function animateProgressBars(ctx = document) {
  $(ctx).find('.bar-container .bar-fill').each(function () {
    const target = parseFloat($(this).attr('style').match(/width:\s*([\d.]+)%/)[1] || 0);
    $(this).css({ width: 0 }); // Reset first
    setTimeout(() => $(this).css({ width: target + '%' }), 50);
  });
}

/**** Update Single Item Quantity Function ****/
function updateQuantity(lineItemKey, quantity, input, sections) {
  let formData = {
    'id': lineItemKey,
    'quantity': quantity,
  };
  if (!sections) {
    formData.sections = getSectionsToRender().map((section) => section.section);
  }
     
  fetch('/cart/change.js?item_quantity_update', {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(responseJson => {
    if(responseJson.description) {
      if(input) input.val(quantity - 1);
      showNotification(window.notificationErrorTemplate(responseJson.description));
      return;
    }
    console.log("responseJson ",responseJson);
    updateCartDrawer(responseJson);
  })
 
}

/**** Update Cart Drawer HTML Function ****/
function updateCartDrawer(response) {
  if (!response) return;
  var cart_drawer_html = new DOMParser().parseFromString(response.sections['cart-drawer'], 'text/html');
  var sourceElement = cart_drawer_html.querySelector('#CartDrawer');

  // var itemCount = sourceElement.querySelector('.cart-drawer-content').getAttribute('data-item-count');
  
  var getSections_Render = getSectionsToRender();
  $.each(getSections_Render, function(key, section) {
   
    const elementToReplace = $('#'+section.id).find(section.selector) || $('#'+section.id);
    if(elementToReplace.length > 0) {
      elementToReplace.html(getSectionInnerHTML(response.sections[section.section], section.selector))
    }
  });
  animateProgressBars('#CartDrawer');
}

/**** Get HTML Functions ****/
function getSectionInnerHTML(html, selector) {
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
}

function getSectionsToRender() {
  return [
    {
      id: 'CartDrawer',
      section: 'cart-drawer',
      selector: '.cart-drawer-form-wrapper',
    },
  ];
}



$(document).ready(function (){
    /**** Mini Drawer on plus and minus click quantity update ****/
    $(document).on("click", ".quantity-down.minus, .plus.quantity-up", function (e) {
      e.preventDefault();
      var input = $(this).closest(".quantity").find(".cart-item__quantity-input");
      console.log("input:: ", input);
      var oldVal = input.val();
      var newVal = 0;
      if ($(this).attr('data-name') == 'plus') {
          newVal = parseInt(oldVal) + 1;
      } else {
          newVal = parseInt(oldVal) - 1;
      }
      console.log("input newVal:: ", newVal);
      input.val(newVal);

        var line_item_key = $(this).parents('.cart-item ').attr('data-key');
        var qty = parseInt(input.val());
        updateQuantity(line_item_key, qty, input);
    });

    /**** Mini Drawer on remove button click item remove ****/
    $(document).on("click", ".cart-item__remove ", function (e) {
        e.preventDefault();
        $(this).addClass('loading__spinner');
        var line_item_key = $(this).parents('.cart-item').attr('data-key');
        updateQuantity(line_item_key, 0);
    });

    /***** Open cart drawer */
    $(document).on("click", "#cart-icon--bubble", function () {
      openCartDrawer();
    });

    /***** Close cart drawer */  
    $(document).on("click", ".drawer__close, .cart-drawer__overlay", function () {
      closeCartDrawer();
    });
    
    // When "Add to Cart" button is clicked
    $(document).on("click", ".product-purchase-form button[type='submit']", function (e) {
      e.preventDefault();

      let $btn = $(this);
      let $form = $btn.closest(".product-purchase-form");

      let defaultText = $btn.text();
      $btn.text("Adding...").prop("disabled", true);

      let variantID = parseInt($form.find('input[name="id"]').val() || $form.find('select[name="id"]').val() || 0);

      let qty = parseInt($form.find('input[name="quantity"]').val()) || 1;

      if (!variantID) {
          alert("Please select a product variant.");
          $btn.text(defaultText).prop("disabled", false);
          return;
      }

      let items = [{ id: variantID, quantity: qty }];

      fetch('/cart/add.js?product_add_to_cart', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items, sections: getSectionsToRender().map(s => s.section) })
      })
      .then(res => res.json())
      .then(data => {
          if (data.description) { 
              showNotification(window.notificationErrorTemplate(data.description));
          } else {
              updateCartDrawer(data); 
              openCartDrawer(); 
          }
          $btn.text(defaultText).prop("disabled", false);
      })
      .catch(err => {
          console.error("Add to cart error:", err);
          $btn.text(defaultText).prop("disabled", false);
      });
    });

    // ================ upsell Add to car code Start =================== 
    $(document).on("click", ".cart-upsell-btn", function (e) {
      e.preventDefault();

      let $btn = $(this);
      let defaultText = $btn.text();
      $btn.text("Adding...").prop("disabled", true);

      let variantID = parseInt($btn.val());
      if (!variantID) {
          console.error("Variant ID not found!");
          $btn.text(defaultText).prop("disabled", false);
          return;
      }

      let items = [{ id: variantID, quantity: 1 }];

      fetch('/cart/add.js?product_add_to_cart', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
              items,
              sections: getSectionsToRender().map(s => s.section)
          })
      })
      .then(res => res.json())
      .then(data => {
          if (data.status && data.status !== 200) {
              console.error("Error:", data.description);
              alert(data.description);
          } else {
              updateCartDrawer(data);
          }
          $btn.text(defaultText).prop("disabled", false);
      })
      .catch(err => {
          console.error("Upsell Add to Cart Error:", err);
          $btn.text(defaultText).prop("disabled", false);
      });
    });

});

// Cart drawer gift
(function () {
  // ---- Config: update selectors if your theme differs
  const WRAPPER_SELECTOR = '.cart-item-wrapper';
  const LIST_SELECTOR    = '.cart-item-wrapper ul.cart-list';
  const DRAWER_ROOT      = document.querySelector('#CartDrawer') || document;

  // ---------- helpers
  async function getCart() {
    const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return r.json();
  }
  async function addVariant(variantId, qty = 1) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty })
    });
    if (!r.ok) throw new Error('Add failed');
    return r.json();
  }
  async function changeLine(line, qty) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity: qty })
    });
    if (!r.ok) throw new Error('Change failed');
    return r.json();
  }
  function getPanel(el = document) {
    return el.querySelector('[data-gift-panel]');
  }
  function getGiftVariantIdSet(panel) {
    const set = new Set();
    panel.querySelectorAll('[data-variant-id]').forEach(el => {
      const id = Number(el.getAttribute('data-variant-id'));
      if (id) set.add(id);
    });
    return set;
  }
  function findGiftLine(cart, giftSet) {
    for (let i = 0; i < cart.items.length; i++) {
      const it = cart.items[i];
      if (giftSet.has(it.variant_id) && it.quantity > 0) return { index: i, item: it };
    }
    return null;
  }
  async function reloadCartList() {
    const wrapper = document.querySelector(WRAPPER_SELECTOR);
    if (!wrapper) return false;
    const sid = wrapper.getAttribute('data-section-id');
    const urls = [];
    if (sid) {
      urls.push(`${location.pathname}?sections=${encodeURIComponent(sid)}`);
      urls.push(`${location.pathname}?section_id=${encodeURIComponent(sid)}`);
    }
    urls.push('/cart?view=drawer');

    for (const url of urls) {
      try {
        const res = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!res.ok) continue;
        let html;
        try { const json = await res.json(); html = (sid && json[sid]) || (json && Object.values(json)[0]); }
        catch { html = await res.text(); }
        if (!html) continue;

        const tmp = document.createElement('div'); tmp.innerHTML = html;
        const fresh = tmp.querySelector(LIST_SELECTOR);
        const old   = document.querySelector(LIST_SELECTOR);
        if (fresh && old) { old.replaceWith(fresh); return true; }
      } catch(e) {}
    }
    return false;
  }

  // ---------- enforce visibility/enabled state for any present panel
  async function enforceAll() {
    const panel = getPanel();
    if (!panel) return;

    const cart = await getCart();
    const threshold = Number(panel.dataset.giftThreshold || 0);
    const eligible  = cart.total_price >= threshold;

    const giftSet = getGiftVariantIdSet(panel);
    const giftLine = findGiftLine(cart, giftSet);
    const hasGift  = Boolean(giftLine);

    // show only when eligible and no scarf in cart
    panel.classList.toggle('is-hidden', !eligible || hasGift);

    // enable swatches only when eligible; leave sold-out disabled from Liquid
    panel.querySelectorAll('.gift-swatch').forEach(sw => {
      const soldOut = sw.classList.contains('is-disabled') || sw.hasAttribute('disabled');
      sw.disabled = !eligible || soldOut;
    });
  }

  // ---------- LIVE (delegated) click for swatches — works even if panel is injected later
  document.addEventListener('click', async (e) => {
    const swatch = e.target.closest('.gift-swatch');
    if (!swatch) return;

    const panel = swatch.closest('[data-gift-panel]');
    if (!panel || swatch.disabled) return;

    // UI: mark selected & update “Choose color” label
    panel.querySelectorAll('.gift-swatch.is-selected').forEach(el => el.classList.remove('is-selected'));
    swatch.classList.add('is-selected');
    const color = swatch.getAttribute('data-color') || '';
    const label = panel.querySelector('[data-selected-color]');
    if (label) label.textContent = color;

    // Ops: add or swap one scarf
    const variantId = swatch.getAttribute('data-variant-id');
    if (!variantId) return;

    try {
      const cart = await getCart();
      const giftSet = getGiftVariantIdSet(panel);
      const giftLine = findGiftLine(cart, giftSet);

      if (!giftLine) {
        await addVariant(variantId, 1);
      } else {
        const newQty = Math.max(0, giftLine.item.quantity - 1);
        await changeLine(giftLine.index + 1, newQty);
        await addVariant(variantId, 1);
      }

      // Refresh the list immediately and hide the panel
      await reloadCartList();
      panel.classList.add('is-hidden');

      // Notify theme for totals/progress updates
      document.dispatchEvent(new CustomEvent('ajaxCart:updated'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (err) {
      console.warn('Gift add/change failed', err);
      alert('That variant is unavailable right now. Please pick another.');
    } finally {
      enforceAll();
    }
  });

  // ---------- keep in sync on any cart/drawer update
  ['ajaxCart:updated','cart:updated','cart:refresh','shopify:section:load','shopify:section:select','cart-drawer:open','DOMContentLoaded']
    .forEach(evt => document.addEventListener(evt, enforceAll));

  // Also observe DOM changes inside the drawer (covers first-time injection)
  const mo = new MutationObserver(() => enforceAll());
  mo.observe(DRAWER_ROOT, { childList: true, subtree: true });

  // First run
  enforceAll();
})();
